import { AssetsView } from "./_components/assets-view";

export default function ContentAssetsPage() {
  return <AssetsView />;
}
